import React from 'react';

const Logo = () => {
  return (
    <h1 className="logoshadow text-5xl lg:text-7xl my-8 text-center text-white font-extrabold uppercase">
      Rich Pulse
    </h1>
  );
};

export default Logo;
